export const hasJsonStructure = (str: any) => {
  if (typeof str !== 'string') return false;
  try {
    const result = JSON.parse(str);
    const type = Object.prototype.toString.call(result);
    return type === '[object Object]' || type === '[object Array]';
  } catch (err) {
    return false;
  }
};

export function capitalizeFirstLetter(value: string) {
  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
}

export function spaceOnCapital(value: string) {
  return value
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .toLowerCase();
}
